import styled from 'styled-components';
import { scale } from '../../common/animations';

const Image = styled.img`
`;

export default Image;
